import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CartService, CartItem } from 'src/app/services/cartservice.service';
import { faTrash, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  app: any;
  cart: CartItem[] = [];
  faTrash = faTrash;
  faArrowLeft = faArrowLeft;

  constructor(
    private router: Router,
    private location: Location,
    private cartService: CartService,
    
  ) {
  }

  ngOnInit() {
    console.log(this.app);
    
    // Get cart items from service
    this.cart = this.cartService.getCartItems();

    // Subscribe to cart items updates
    this.cartService.cartItems$.subscribe(items => {
      this.cart = items;
    });

  }

  addToCart(app: any) {
    this.cartService.addToCart(app);
  }

  getTotal(): number {
    return this.cartService.getTotal();
  }

  getVat(): number {
    return this.cartService.getVat();
  }

  onCheckboxChange(item: CartItem, event: Event): void {
    const target = event.target as HTMLInputElement;
    this.cartService.updateItemSelection(item.name, target.checked);
  }

  removeFromCart(item: CartItem): void {
    this.cartService.removeFromCart(item.name);
  }

  removeSelectedItems(): void {
    this.cartService.removeSelectedItems();
  }

  clearCart(): void {
    this.cartService.clearCart();
  }

  hasSelectedItems(): boolean {
    return this.cart.some(item => item.selected === true);
  }

  goBack(): void {
    this.location.back();
  }

  async checkout(): Promise<void> {
    const total = this.getTotal();
    if (total <= 0) {
      Swal.fire({
        text: 'Please select at least one item to checkout.',
        icon: 'warning',
        confirmButtonColor: '#9fc754',
      });
      return;
    }

    try {
      const body = {
        amount: Number(total),
        items: this.cart.map((item) => ({
          ...item,
          price: Number(item.price),
        })),
      };
      console.log(body);
      const data:any = await this.cartService.checkout(body);
      console.log(data);

      if (data.success === false) {
        Swal.fire({
          text: 'Checkout failed. Please try again.',
          icon: 'error',
          confirmButtonColor: '#9fc754',
        });
        return;
      }

      const paymentUrl = data.payment_url;
      // window.open(paymentUrl);
      window.open(paymentUrl, '_blank');

    } catch (error: any) {
      const message =
        error?.error?.message ||
        error?.message ||
        'Checkout failed. Please try again.';
      Swal.fire({
        text: message,
        icon: 'error',
        confirmButtonColor: '#9fc754',
      });
    }
  }

}
